export { RelatedProductsSection } from './RelatedProductsSection';
